import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { SaveMission } from '../../../store/actions/mission.actions';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { select, Store } from '@ngrx/store';
import { ChangeNetworkInterface } from '../../../models/change-network.interface';
import { GetPortabilityDates } from '../../../store/actions/portability-dates.actions';
import { LineInterface } from '../../../../lines/models/line.interface';
import { PriceDetailsInterface } from '../../../models/price-details.interface';
import { AddressInterfaceState } from '../../../../account/store/state/address.state';
import { AddressInterface } from '../../../../account/models/address.interface';
import { GetAddress } from '../../../../account/store/actions/address.actions';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import moment from 'moment';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl } from '@angular/forms';
import { environment } from '../../../../../../environments/environment';

@Component({
    selector: 'app-change-network',
    templateUrl: './change-network.component.html',
    styleUrls: ['./change-network.component.css'],
    standalone: false
})
export class ChangeNetworkComponent implements OnInit {
    @Input()
    line: LineInterface;

    @Input()
    priceDetails?: PriceDetailsInterface;

    @Input()
    procedureCode: string;

    @Input()
    dates: Array<string>;

    dateChange: EventEmitter<MatDatepickerInputEvent<Date>>;
    validDates: Date[];

    shippingAddress: AddressInterface|null;
    startDate: FormControl;
    selectedDate: Date;
    displayError: boolean;
    formSubmitted: boolean;
    brand?: string;

    constructor(
        private store: Store<any>,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
    ) {
    }

    ngOnInit() {
        this.brand = environment.data.brand;
        this.shippingAddress = null;
        this.displayError = false;
        this.formSubmitted = false;
        this.initDates(this.dates);
        this.store.pipe(select(ConstsHelper.REDUCER_ADDRESS)).subscribe((result: AddressInterfaceState) => {
            if (null != result.address) {
                for (const addr of result.address) {
                    if (addr.isPrincipal) {
                        this.shippingAddress = addr;
                    }
                }
            }
        });

        this.store.dispatch(new GetPortabilityDates());
        this.store.dispatch(new GetAddress());
        this.matIconRegistry.addSvgIcon(
            'agenda',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../../../../../../../assets/images/icons/' + this.brand + '_small-agenda.svg'
            )
        );
    }

    initDates(dates: string[]) {
        this.validDates = [];
        dates.forEach(d => {
            const momentDate = moment(d, 'DD/MM/YYYY');
            this.validDates.push(new Date(momentDate.format('YYYY-MM-DD')));
        });
        this.selectedDate = this.validDates[0];
        this.startDate = new FormControl(this.validDates[0]);
    }

    setSelectedDate(event) {
        this.selectedDate = event;
    }

    confirmation() {
        this.displayError = false;
        if (this.dates.indexOf(moment(this.selectedDate).format('DD/MM/YYYY')) !== -1 && this.formSubmitted === false) {
            this.formSubmitted = true;
            const changeNetworkInterface = {
                phoneNumber: this.line.phoneNumber,
                step: 1,
                offerName: this.line.offer.labelTunnel,
                network: this.line.network.toLowerCase() === 'sfr' ? 'orange' : 'sfr',
                portabilityDate: moment(this.selectedDate).format('YYYY-MM-DD'),
            } as ChangeNetworkInterface;
            this.store.dispatch(new SaveMission(changeNetworkInterface, this.procedureCode));
        } else {
            this.displayError = true;
        }
    }

    portabilityDateFilter = (forDay: Date | null): boolean => {
        return this.validDates.some(
            (date) => date.toDateString() === forDay.toDateString()
        );
    }

    cancel() {
        this.store.dispatch(new UpdateSelectedProcedure(''));
    }
}
